var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customize-report"},[_c('h1',[_vm._v("自定义报表")]),_c('p',[_vm._v("报表功能开发中...")])])
}]

export { render, staticRenderFns }